import { ApolloError } from "@apollo/client";

/**
 * Extract a user-displayable message from an Apollo error.
 * Returns the first GraphQL error's message (already formatted by the backend's
 * `formatError` as a UserFacingError string), or the caller-supplied fallback
 * for network / non-Apollo failures. Returns `null` for a null/undefined input
 * so callers can render a banner conditionally without an extra guard.
 */
export function apolloErrorMessage(
  err: unknown,
  fallback: string,
): string | null {
  if (!err) return null;
  if (err instanceof ApolloError) {
    return err.graphQLErrors[0]?.message || fallback;
  }
  return fallback;
}

/**
 * Extract the backend `extensions.code` from the first GraphQL error (e.g.
 * `SSO_ENFORCED`, `SIGN_IN_NOT_ELIGIBLE`). Returns `null` for network errors or
 * non-Apollo inputs. Lets callers branch on a stable code instead of parsing
 * the (localised, mutable) message string.
 */
export function apolloErrorCode(err: unknown): string | null {
  if (err instanceof ApolloError) {
    const code = err.graphQLErrors[0]?.extensions?.code;
    return typeof code === "string" ? code : null;
  }
  return null;
}
